import React from 'react';
import { RouteProps } from 'react-router';
import { NotFound } from '~frontend-common/components/ui';
import { Box } from '~ui-kit/components/box';
import { Images } from '~web-portal/theme/images';
import { Paths } from '~web-portal/variables/paths';

export function NotFoundPage(props: RouteProps) {
  return (
    <Box data-id="page-not-found" flexDirection="column" justifyContent="center" minHeight="100vh">
      <NotFound redirectionPath={Paths.start} imagesSrc={Images} {...props} />
    </Box>
  );
}
